import HistoryScreen from "./index";
import HistoryReportScreen from "./report";

const routes = [
  {
    path: "/riwayat",
    component: HistoryScreen,
  },
  {
    path: "/riwayat/report/:id",
    component: HistoryReportScreen,
  },
];

export default routes;
